
import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const BotService = {

    saveNode: (data: any) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.BOT_V3}builder/save-node`, data);
    },
    updateNode: (data: any) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.BOT_V3}builder/update-node`, data);
    },
    updateCoordinates: (data: any) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.BOT_V3}builder/update-coordinates`, data);
    },
    deployBoy: (data: any) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.BOT_V3}builder/deploy`, data);
    },
    getTreeV2: (account_id: number, ambiente: string) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/show-bot`, { params: { account_id, ambiente } });
    },
    getInfoNodeV2: (step_id: number, ambiente: string) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.BOT_V2}create-flow/v2.0/get-step-detail`, { params: { step_id, ambiente } });
    },
    getTree: (bot_id: number, is_sandox: string, main_flow?: number) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.BOT_V3}builder/get-tree`, { params: { bot_id, is_sandox, main_flow } });
    },
    deleteNode: (_id: string) => {
        return HTTP.delete<any, any>(`${API_ENDPOINT.BOT_V3}builder/delete`, { data: { _id }});
    },
    handleConnector: (data: any) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.BOT_V3}builder/handle-connector`, data );
    },
    register: (data: any) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.BOT_V3}bots/register`, data );
    },
    setStatus: (data: any) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.BOT_V3}bots/set-status`, data );
    },
    getChatbotInfo: (account_id: number | string) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/v4/settings-bot/info/${account_id}`);
    },
    flowV2: (data: any) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.BOT_V2}flow`, data);
    },
    flow: (data: any) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.BOT_V3}interaction/flow`, data);
    },
    
    uploadFile: (data: FormData) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.BOT_V3}assets/upload`, data);
    },
}